<template>
  <z-card-modal
    persistent
    :opened="opened"
    width="720px"
    @change="$emit('close')"
  >
    <template #content>
      <div class="d-flex flex-column mt-3 mb-5 align-center">
        <section
          class="main-content-modal p-5"
          style="max-height: 400px; overflow-y: auto; overflow-x: hidden"
        >
          <div class="p-5 content" v-html="terms.terms"></div>
        </section>

        <z-btn
          data-cy="understand-btn"
          class="understand-btn mt-5"
          :width="$vuetify.breakpoint.smAndDown ? '100%' : '50%'"
          primary
          :text="$t('modal.use_terms_modal.ok_btn')"
          @click="$emit('close')"
        />

        <z-btn
          class="send-terms-mail mt-5"
          :width="$vuetify.breakpoint.smAndDown ? '100%' : '50%'"
          :text="$t('modal.use_terms_modal.send_terms')"
          @click="$emit('click:send_terms', 'use')"
        />
      </div>
    </template>
  </z-card-modal>
</template>

<script>
export default {
  props: {
    opened: {
      type: Boolean,
      default: false,
    },
    terms: {
      type: Object,
      default: () => {},
    },
  },
  setup() {},
}
</script>

<style scoped lang="scss">
.content {
  max-width: 100%;
  margin: 0 auto;
  padding: 8px;
}
@media screen and (max-width: 960px) {
  .content {
    text-align: justify;
    max-width: 90%;
    margin: 0 auto;
    padding: 20px;
    :nth-child(2) {
      margin: 0 !important;
      padding: 0 !important;
      margin: 0 auto !important;
      max-width: 90%;
    }
    :nth-child(3) {
      margin-top: 20px !important;
    }
  }
}
</style>
